import React from 'react';

/**
 * PlanBadge component to indicate which plan is required for a feature
 * @param {string} plan - Plan name: 'free', 'starter', 'growth', 'pro'
 * @param {string} size - Size: 'sm' or 'md' (default: 'md')
 */
export default function PlanBadge({ plan, size = 'md' }) {
  const planConfig = {
    free: {
      label: 'Free',
      colors: 'bg-gray-100 text-gray-700 border-gray-300'
    },
    starter: {
      label: 'Starter',
      colors: 'bg-blue-100 text-blue-700 border-blue-300'
    },
    growth: {
      label: 'Growth',
      colors: 'bg-purple-100 text-purple-700 border-purple-300'
    },
    pro: {
      label: 'Pro',
      colors: 'bg-indigo-100 text-indigo-700 border-indigo-300'
    }
  };

  const config = planConfig[plan] || planConfig.free;
  const sizeClasses = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-2.5 py-1';

  return (
    <span
      className={`inline-flex items-center font-semibold rounded border ${config.colors} ${sizeClasses}`}
    >
      {config.label}+
    </span>
  );
}
